import React, { useState, useEffect } from "react";
import "../../styles/pages.css";
import ReleasesImg from "../../assets/images/releases.png";
import ReleasesThumb from "../../assets/images/releasesthumb.png";
import Pagination from "../ui/Pagination";
import EnSearchBar from "../ui/EnSearchBar";
import "../../styles/banner.css";
import { getListBoardRelease } from "../../api";

const Banner = ({ backgroundImage, title, description }) => {
  return (
    <div className="page-banner" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="banner-content">
        <h1>{title}</h1>
        {typeof description === "string" ? <p>{description}</p> : Array.isArray(description) ? description.map((line, index) => <p key={index}>{line}</p>) : null}
      </div>
    </div>
  );
};

const EnReleases = () => {
  // Pagination 시작
  const [currentPage, setCurrentPage] = useState(1);
  const [displayedReleasess, setDisplayedReleasess] = useState([]);
  const releasessPerPage = 15;
  const [dataCount, setDataCount] = useState(1);
  // Pagination 끝

  // 검색바
  // const [originalReleases, setOriginalReleases] = useState([]);
  // const [filteredReleasess, setFilteredReleasess] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // 언어 설정
  const currentLang = "en";

  // 초기 로드 시 모든 시공사례 설정
  useEffect(() => {
    (async () => {
      const res = await getListBoardRelease({
        category: "뉴스",
        page: currentPage,
        search: searchTerm.trim() || undefined,
        lang: currentLang,
      });
      const data = res.data.results;
      setDataCount(res.data.count);
      setDisplayedReleasess(data);
    })();
  }, [currentPage, searchTerm]);

  // 검색어에 따라 시공사례 필터링
  useEffect(() => {
    // if (searchTerm.trim() === "") {
    //   setFilteredReleasess(originalReleases);
    // } else {
    //   const filtered = originalReleases.filter((releases) => releases.title.toLowerCase().includes(searchTerm.toLowerCase()) || releases.content.toLowerCase().includes(searchTerm.toLowerCase()));
    //   setFilteredReleasess(filtered);
    // }
    setCurrentPage(1); // 검색 시 첫 페이지로 이동
  }, [searchTerm]);

  // 페이지 변경 시 표시할 시공사례 업데이트
  // useEffect(() => {
  //   const indexOfLastReleases = currentPage * releasessPerPage;
  //   const indexOfFirstReleases = indexOfLastReleases - releasessPerPage;
  //   setDisplayedReleasess(filteredReleasess.slice(indexOfFirstReleases, indexOfLastReleases));
  // }, [currentPage, filteredReleasess]);

  const handlePageChange = (pageNumber) => {
    const target = Math.max(1, Math.min(pageNumber, totalPages));
    setCurrentPage((prev) => (prev === target ? prev : target));
    window.scrollTo({
      top: document.querySelector(".releases-section").offsetTop - 100,
      behavior: "smooth",
    });
  };

  const handleSearch = (term) => {
    setCurrentPage(1);
    setSearchTerm(term);
  };

  const totalPages = Math.ceil((dataCount ?? 0) / releasessPerPage);

  const bannerDescription = ["ECOTECH GLOBAL's New Start, Check It Out Now.", "Here are news of new products and technology updates for better agriculture."];

  return (
    <div className="releases-container">
      <Banner backgroundImage={ReleasesImg} title="Release" description={bannerDescription} />
      <div className="releases-content">
        <div className="releases-description">
          <h2>News</h2>
          <p>
            Changes in agricultural technology, ecosystems are created.
            <br />
            Introducing vivid news from industrial news to the field-oriented practice.{" "}
          </p>
        </div>
        <div className="releases-section">
          <div className="releases-info">
            <p>{dataCount} items</p>
            <EnSearchBar onSearch={handleSearch} />
          </div>
          <hr />

          {displayedReleasess && displayedReleasess.length > 0 ? (
            <div className="releases-grid">
              {displayedReleasess.map((releases) => (
                <div
                  key={releases.id}
                  className="releases-box"
                  onClick={() => window.open(releases.link, "_blank")}
                  role="button"
                  tabIndex={0}
                  // onKeyDown={(e) => {
                  //   if (e.key === "Enter" || e.key === " ") {
                  //     handleReleasesClick(releases.detailUrl);
                  //   }
                  // }}
                >
                  <div className="releases-thumbnail-container">
                    <img src={releases.thumbnail?.file?.url ? `${releases.thumbnail.file.url}` : ReleasesThumb} alt={releases.title} className="releases-thumbnail" />
                  </div>
                  <div className="releases-title">
                    <div className="releases-titlecontent">
                      <h3>{releases.en_translations[0]?.title_en || releases.title}</h3>
                      <p>{releases.en_translations[0]?.content_en || releases.content}</p>
                    </div>
                    <div className="releases-date">
                      <span>{releases.date}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-results">
              <p>There is no result.</p>
            </div>
          )}
          {totalPages > 1 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />}
        </div>
      </div>
    </div>
  );
};

export default EnReleases;
